export const getRedirectLink = (hasRedirectLink) => hasRedirectLink?.deeplink;

export const getDeeplink = (hasDeeplink) => hasDeeplink?.deeplink;
